import type { FactEvidencePayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A record fact from the beneficiary's file, `type: 'fact'` discriminant. `value` is the text
 * frozen at generation time — never re-read from the live record.
 */
class FactEvidenceView {
	readonly type: 'fact';
	readonly key: string;
	readonly label: string;
	readonly value: string;

	constructor(payload: FactEvidencePayload) {
		this.type = 'fact';
		this.key = payload.key;
		this.label = payload.label;
		this.value = payload.value;

		Object.freeze(this);
	}
}

export default FactEvidenceView;
